import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import profileApi from "api/profile";
import { scrollIntoView } from "utils/helper";

function useEmergencyContact() {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);

  const { notifyError, notifySuccess } = useNotify();

  const onEditSave = async (values) => {
    try {
      setIsLoading(true);

      const {
        name,
        relationship,
        email,
        emergencyCountry,
        emergencyPhoneNumber,
        emergencyHomeTelephone,
      } = values;

      const payload = {
        emergencyContacts: {
          name,
          relationship,
          email,
          country: emergencyCountry,
          mobileNumber: emergencyPhoneNumber,
          homeTelephone: emergencyHomeTelephone,
        },
      };

      await profileApi.updateEmergencyContact(userDetails?.vendorId, payload);

      const updatedUserDetails = {
        ...userDetails,
        extraInformation: {
          ...userDetails.extraInformation,
          emergencyContactDetails: {
            name,
            relationship,
            email,
            country: emergencyCountry,
            mobileNumber: emergencyPhoneNumber,
            homeTelephone: emergencyHomeTelephone,
          },
        },
      };
      dispatch(actions.setUserDetails(updatedUserDetails));

      notifySuccess(t("emergencyContactUpdated"));
      scrollIntoView("emergencyContactScrollId");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    onEditSave,
    isLoading,
  };
}

export default useEmergencyContact;
